import { takeEvery, fork, put, all, call } from "redux-saga/effects"

//Account Redux states
import { getCandidateMasterReportSuccessful, getCandidateMasterReportFailed, getReportDownloadFailed, getReportDownloadSuccessfull } from "./action"


import {
  getRequest
} from "../../../helpers/fakebackend_helper"

//restapi end point
import * as constClass from "../../../common/constant/constantURL"
import { CANDIDATE_REPORT, CANDIDATE_REPORT_DOWNLOAD, JOB_PERFORMANCE_REPORT, JOB_PERFORMANCE_REPORT_DOWNLOAD, JOB_REPORT, JOB_REPORT_DOWNLOAD  } from "./actionType"



function* getCandidateReports({ payload: { user } }) {
  try 
  {
    let param = `?page=${user.pageNumber}&pageSize=${user.pageSize}`
   
    if(user?.startDate)
    {
      param+=`&startDateInMilli=${user.startDate}&endDateInMilli=${user.endDate}`
    }
    if(user?.sort!==undefined && user?.sort!==null && user?.sort!=="")
    {
      param+=`&sort=${user.sort}`
    }
    if(user?.searchKeyword)
    {
      param+=`&keyword=${user?.searchKeyword}`
    }
    
    var url=constClass.REST_API_REPORTS+param;
     var responsJSON = yield call(getRequest, url);
     
     yield put(getCandidateMasterReportSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(getCandidateMasterReportFailed(error))
  }
}

function* getDownloadReports({ payload: { user } }) {
  try 
  {
    let param = `?fileType=${user.type}${user.params}`

   
    if(user?.startDate)
    {
      param+=`&startDateInMilli=${user.startDate}&endDateInMilli=${user.endDate}`
    }
    if(user?.sort!==undefined && user?.sort!==null && user?.sort!=="")
    {
      param+=`&sort=${user.sort}`
    }
    if(user?.searchKeyword)
    {
      param+=`&keyword=${user?.searchKeyword}`
    }
    if(user?.period)
    {
      param+=`&duration=${user?.period}`
    }
    var url=`report/${user.report}/download`+param;

     var responsJSON = yield call(getRequest, url);
     
     yield put(getReportDownloadSuccessfull(responsJSON))
  } 
  catch (error) 
  {
    yield put(getReportDownloadFailed(error))
  }
}


function* getJobReports({ payload: { user } }) {
  try 
  {
    let param = `?page=${user.pageNumber}&pageSize=${user.pageSize}`
   
    if(user?.startDate)
    {
      param+=`&startDateInMilli=${user.startDate}&endDateInMilli=${user.endDate}`
    }
    if(user?.sort!==undefined && user?.sort!==null && user?.sort!=="")
    {
      param+=`&sort=${user.sort}`
    }
    if(user?.searchKeyword)
    {
      param+=`&keyword=${user?.searchKeyword}`
    }
    
    var url=constClass.REST_API_JOB_REPORTS+param;
     var responsJSON = yield call(getRequest, url);
     
     yield put(getCandidateMasterReportSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(getCandidateMasterReportFailed(error))
  }
}

function* getJobDownloadReports({ payload: { user } }) {
  try 
  {
    let param = `?type=${user.type}`
   
    if(user?.startDate)
    {
      param+=`&startDateInMilli=${user.startDate}&endDateInMilli=${user.endDate}`
    }
    if(user?.sort!==undefined && user?.sort!==null && user?.sort!=="")
    {
      param+=`&sort=${user.sort}`
    }
    if(user?.searchKeyword)
    {
      param+=`&keyword=${user?.searchKeyword}`
    }
    if(user?.period)
    {
      param+=`&duration=${user?.period}`
    }
    var url=constClass.REST_API_JOB_REPORTS+"/download"+param;
     var responsJSON = yield call(getRequest, url);
     
     yield put(getReportDownloadSuccessfull(responsJSON))
  } 
  catch (error) 
  {
    yield put(getReportDownloadFailed(error))
  }
}


function* getJobPerformanceReports({ payload: { user } }) {
  try 
  {
    let param = `?page=${user.pageNumber}&pageSize=${user.pageSize}`
   
    if(user?.startDate)
    {
      param+=`&startDateInMilli=${user.startDate}&endDateInMilli=${user.endDate}`
    }
    if(user?.sort!==undefined && user?.sort!==null && user?.sort!=="")
    {
      param+=`&sort=${user.sort}`
    }
    if(user?.searchKeyword)
    {
      param+=`&keyword=${user?.searchKeyword}`
    }
    
    var url=constClass.REST_API_JOB_PERFORMANCE_REPORTS+param;
     var responsJSON = yield call(getRequest, url);
     
     yield put(getCandidateMasterReportSuccessful(responsJSON))
  } 
  catch (error) 
  {
    yield put(getCandidateMasterReportFailed(error))
  }
}

function* getJobPerformanceDownloadReports({ payload: { user } }) {
  try 
  {
    let param = `?type=${user.type}`
   
    if(user?.startDate)
    {
      param+=`&startDateInMilli=${user.startDate}&endDateInMilli=${user.endDate}`
    }
    if(user?.sort!==undefined && user?.sort!==null && user?.sort!=="")
    {
      param+=`&sort=${user.sort}`
    }
    if(user?.searchKeyword)
    {
      param+=`&keyword=${user?.searchKeyword}`
    }
    if(user?.period)
    {
      param+=`&duration=${user?.period}`
    }
    var url=constClass.REST_API_JOB_PERFORMANCE_REPORTS+"/download"+param;
     var responsJSON = yield call(getRequest, url);
     
     yield put(getReportDownloadSuccessfull(responsJSON))
  } 
  catch (error) 
  {
    yield put(getReportDownloadFailed(error))
  }
}



export function* reportWatcher() {
  yield takeEvery(CANDIDATE_REPORT, getCandidateReports)
  yield takeEvery(CANDIDATE_REPORT_DOWNLOAD, getDownloadReports)
  yield takeEvery(JOB_REPORT, getJobReports)
  yield takeEvery(JOB_REPORT_DOWNLOAD, getJobDownloadReports)
  yield takeEvery(JOB_PERFORMANCE_REPORT, getJobPerformanceReports)
  yield takeEvery(JOB_PERFORMANCE_REPORT_DOWNLOAD, getJobPerformanceDownloadReports)
}

function* reportSaga() {
  yield all([fork(reportWatcher)])
}

export default reportSaga
